/**
 * Returns true if the given href is an absolute URL (http/https) pointing to
 * a different origin than tzero.com. Relative paths, mailto:, tel:, and same-
 * origin URLs return false.
 */
export function isExternalUrl(href: string | null | undefined): boolean {
  if (href == null || typeof href !== "string") return false;
  const s = href.trim();
  if (!s) return false;
  // Relative path or hash-only
  if (s.startsWith("/") || s.startsWith("#")) return false;
  // Non-http(s) protocols
  if (!s.startsWith("http://") && !s.startsWith("https://")) return false;
  try {
    const u = new URL(s);
    const host = u.hostname.toLowerCase();
    // Same-site: tzero.com, www.tzero.com, and any subdomain of tzero.com
    return !(host === "tzero.com" || host === "www.tzero.com" || host.endsWith(".tzero.com"));
  } catch {
    return false;
  }
}
